<template>
    <b-form-group
        :label="showLabel ? $t('permissions.permissions') : null"
        label-for="permissions"
    >
        <Select
            id="permissions-select"
            class="mb-2"
            :state="state"
            :selected="editOption"
            :options="editOptions"
            :disabled="disabled"
            @changeValue="$emit('update:editOption', $event)"
        />
        <b-form-checkbox-group
            id="permissions"
            :options="options"
            :value="value"
            :state="state"
            @change="$emit('update:value', $event)"
        />
        <b-form-invalid-feedback>
            <span>
                {{ $t('usersBulkEdit.messages.selectTheDesiredModules') }}
            </span>
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import i18n from '@/i18n'
import permissionsEditOptions from '@/data/permissionsUpdateOptions'
import { Select } from '@/views/components/selects'

export default {
    name: 'EnablePermissions',
    components: {
        Select,
    },
    props: ['value', 'disabled', 'state', 'showLabel', 'editOption'],
    data() {
        return {
            selected: [],
            options: [],
            editOptions: permissionsEditOptions,
            loading: true,
        }
    },
    mounted() {
        const defaultOption = this.editOptions.find(option => option.isDefault)
        this.$emit('update:editOption', defaultOption)
        this.getPermissions()
    },
    methods: {
        getPermissions() {
            this.options = [
                {
                    value: 'is_values_master',
                    text: i18n.t('permissions.isValueMaster'),
                },
                {
                    value: 'is_target_master',
                    text: i18n.t('permissions.isTargetMaster'),
                },
                {
                    value: 'has_360_visualization',
                    text: i18n.t('permissions.has360Visualization'),
                },
                {
                    value: 'has_admin_access',
                    text: i18n.t('permissions.accessToTheSettingsPanel'),
                },
            ]
        },
        mapperToOptions(modules) {
            return modules.map(module => {
                return {
                    text: this.defaultModules[module],
                    value: module,
                }
            })
        },
    },
}
</script>
